module.exports = __webpack_public_path__ + "img/demo1.d77badc7.png";